module.exports = __webpack_public_path__ + "img/mickey94.1b498bd6.jpg";